<template lang="pug">
  tr.table__row
    td.table__cell {{ `perm.${row.label}.${row.name}` | translate }}
    td.table__cell(
      v-for="type in accessTypes"
      :key="type")
      toggle-dot.cursor-pointer(
        :disabled="!row[type]"
        v-model="row[`v_${type}`]")
    td.table__cell
      toggle-dot.cursor-pointer(
        :value="isAllSelected"
        @input="toggleAll")
</template>

<script>
import ToggleDot from '@/components/common/toggle-dot/ToggleDot'

export default {
  name: 'PermItem',

  props: {
    row: Object
  },

  components: {
    ToggleDot
  },

  data: () => ({
    accessTypes: [
      'view',
      'add',
      'change',
      'delete'
    ]
  }),

  computed: {
    isAllSelected () {
      return this.row.v_view &&
        this.row.v_add &&
        this.row.v_change &&
        this.row.v_delete
    }
  },

  methods: {
    toggleAll (value) {
      for (const type of this.accessTypes) {
        this.row[`v_${type}`] = value
      }
    }
  }
}
</script>
